@if (userId && isCargoMart) {
  <div
    #notiDropdown="ngbDropdown"
    ngbDropdown
    (openChange)="onSeenNotification($event)"
    placement="bottom-right"
    autoClose="outside"
    class="kt-header__topbar-item"
  >
    <div ngbDropdownToggle class="kt-header__topbar-wrapper">
      <span class="kt-header__topbar-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 3C8.06797 3 4.75125 5.92794 4.26354 9.82963L3.27462 17.741C3.0583 19.4715 4.40764 21 6.15162 21H7.35024C8.17591 22.8255 9.99442 24 12 24C14.0056 24 15.8241 22.8255 16.6497 21H17.8484C19.5924 21 20.9417 19.4715 20.7254 17.741L19.7365 9.82963C19.2488 5.92794 15.9321 3 12 3ZM16.0228 19C16.0079 18.9997 15.9931 18.9997 15.9783 19H8.02171C8.00689 18.9997 7.99204 18.9997 7.97718 19H6.15162C5.61064 19 5.19207 18.5259 5.25917 17.9891L6.24809 10.0777C6.6107 7.17687 9.07662 5 12 5C14.9234 5 17.3893 7.17687 17.752 10.0777L18.7409 17.9891C18.808 18.5259 18.3894 19 17.8484 19H16.0228ZM9.71801 21H14.282C13.7043 21.6265 12.8819 22 12 22C11.1181 22 10.2957 21.6265 9.71801 21Z"
            fill="currentColor"
          />
        </svg>
        @if (showNotificationBadge && notificationUnseen.length > 0) {
          <div class="badge-number">
            {{ notificationUnseen.length }}
          </div>
        }
      </span>
    </div>
    <div
      ngbDropdownMenu
      class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
    >
      <form>
        <!--begin: Head -->
        <div class="kt-head notification-bg kt-head--fit-x kt-head--fit-b">
          <h3 class="title" i18n="@@global.notifications">Notifications</h3>
        </div>
        <!--end: Head -->
        <ul ngbNav>
          <li ngbNavItem id="tab-id-1">
            @if (notifications?.length === 0) {
              <div ngbNavContent>
                <div
                  class="d-flex flex-column justify-content-center empty-notification"
                >
                  <p class="text-center">
                    <span i18n="@@notifications.all-caught-up"
                      >All caught up!</span
                    >
                    <br /><span i18n="@@notifications.no-new-notifications"
                      >No new notifications.</span
                    >
                  </p>
                </div>
              </div>
            }
            @if (notifications?.length > 0) {
              <div ngbNavContent>
                <div
                  [ngStyle]="{
                    'max-height': '40vh',
                    position: 'relative',
                    'overflow-y': 'scroll',
                  }"
                  class="kt-notification kt-margin-t-10 kt-margin-b-10 custom-scroll-bar"
                >
                  <div class="notification-top">
                    @if (notificationUnread.length) {
                      <span
                        class="notification-mark"
                        (click)="onMarkAllRead()"
                        i18n="@@notifications.mark-all-as-read"
                        >Mark all as read</span
                      >
                    }
                  </div>
                  @for (noti of getNotificationsList(); track noti) {
                    @if (notificationToday(noti)) {
                      <div class="notification-today">
                        <span i18n="@@global.today">Today</span>
                      </div>
                    }
                    @if (notificationOlder(noti)) {
                      <div class="notification-older">
                        <span i18n="@@global.older">Older</span>
                      </div>
                    }
                    <div
                      class="notification-wrapper"
                      (click)="
                        onQuoteDetailWrapperClick(noti); notiDropdown.close()
                      "
                    >
                      <div class="notification-avatar">
                        <img
                          [src]="getAvatar(noti)"
                          alt="Avatar"
                          onerror="this.onerror=null;this.src='/assets/media/icons/default-company-icon.png';"
                        />
                      </div>
                      <div class="notification-content">
                        <div class="notification-title-wrapper">
                          <div class="notification-main">
                            <span class="notification-title">
                              {{ formatNotificationTitle(noti) }}
                            </span>
                          </div>
                          <div class="notification-time">
                            {{ formatTimeFromNow(noti) }}
                          </div>
                          <div
                            class="notification-action"
                            (click)="
                              updateNotification(
                                noti.timestamp,
                                !noti.read,
                                true
                              );
                              $event.stopPropagation()
                            "
                            [ngStyle]="{ display: noti.read ? 'none' : '' }"
                          >
                            <div class="notification-pill"></div>
                            <div
                              [matTooltip]="noti.read ? 'Mark as unread' : null"
                              class="notification-unread"
                              [ngStyle]="{
                                background: noti.read ? 'transparent' : '',
                              }"
                            ></div>
                          </div>
                        </div>
                        @if (formatBidInformation(noti)) {
                          <div class="bid-information">
                            <svg
                              width="17"
                              height="20"
                              viewBox="0 0 17 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.0577 10.1578L9.19043 10.6764V20.0001L16.9999 15.3403V6.01672L10.0577 10.1578Z"
                                fill="#4D578D"
                              />
                              <path
                                d="M11.471 1.79667L8.4677 0L0.441406 4.78836L3.44876 6.58503L11.471 1.79667Z"
                                fill="#4D578D"
                              />
                              <path
                                d="M16.4902 4.78819L13.0291 2.75085L5.00684 7.53921L5.46456 7.78402L8.4679 9.57654L11.4552 7.79647L16.4902 4.78819Z"
                                fill="#4D578D"
                              />
                              <path
                                d="M4.40061 10.9665L2.96319 10.2031V7.82964L0 6.06616V15.3234L7.75327 19.9499V10.6927L4.40061 8.69685V10.9665Z"
                                fill="#4D578D"
                              />
                            </svg>
                            <a
                              class="text-primary commodity-text"
                              routerLink="{{ getQuoteDetailLink(noti) }}"
                              >{{ getCommodity(noti) }}</a
                            >
                            <span>
                              <span
                                style="margin: 0 3px 0 8px; color: #4d578d"
                                >{{ formatBidInformation(noti) }}</span
                              >
                              <span class="calendar-icon"
                                ><svg
                                  width="21"
                                  height="21"
                                  viewBox="0 0 21 21"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M7.75 0.875C7.75 0.460786 7.41421 0.125 7 0.125C6.58579 0.125 6.25 0.460786 6.25 0.875V1.89657C6.06892 1.90852 5.90625 1.92708 5.75219 1.95588C3.82438 2.31625 2.31625 3.82438 1.95588 5.75219C1.87481 6.18586 1.87488 6.6878 1.87499 7.47652L1.875 7.56618V11.975L1.875 12.008C1.87499 13.1001 1.87499 13.9656 1.93199 14.6633C1.99027 15.3767 2.11188 15.9803 2.39272 16.5315C2.84812 17.4252 3.57478 18.1519 4.46855 18.6073C5.01972 18.8881 5.62334 19.0097 6.33673 19.068C7.03435 19.125 7.89984 19.125 8.99198 19.125H9.025H11.975H12.008C13.1002 19.125 13.9656 19.125 14.6633 19.068C15.3767 19.0097 15.9803 18.8881 16.5315 18.6073C17.4252 18.1519 18.1519 17.4252 18.6073 16.5315C18.8881 15.9803 19.0097 15.3767 19.068 14.6633C19.125 13.9656 19.125 13.1002 19.125 12.008V11.975V9.025V8.99198C19.125 7.89984 19.125 7.03435 19.068 6.33673C19.0097 5.62334 18.8881 5.01972 18.6073 4.46854C18.1519 3.57478 17.4252 2.84812 16.5315 2.39272C16.0028 2.12333 15.4258 2.00046 14.75 1.93944V0.875C14.75 0.460786 14.4142 0.125 14 0.125C13.5858 0.125 13.25 0.460786 13.25 0.875V1.87902C12.8719 1.875 12.4593 1.875 12.008 1.875L11.975 1.875H7.75V0.875ZM5.37501 7C5.37501 6.58579 5.7108 6.25 6.12501 6.25H14.875C15.2892 6.25 15.625 6.58579 15.625 7C15.625 7.41421 15.2892 7.75 14.875 7.75H6.12501C5.7108 7.75 5.37501 7.41421 5.37501 7ZM7.00001 11.375C7.48326 11.375 7.87501 10.9832 7.87501 10.5C7.87501 10.0168 7.48326 9.625 7.00001 9.625C6.51676 9.625 6.12501 10.0168 6.12501 10.5C6.12501 10.9832 6.51676 11.375 7.00001 11.375ZM7.87501 14C7.87501 14.4832 7.48326 14.875 7.00001 14.875C6.51676 14.875 6.12501 14.4832 6.12501 14C6.12501 13.5168 6.51676 13.125 7.00001 13.125C7.48326 13.125 7.87501 13.5168 7.87501 14ZM10.5 14.875C10.9833 14.875 11.375 14.4832 11.375 14C11.375 13.5168 10.9833 13.125 10.5 13.125C10.0168 13.125 9.62501 13.5168 9.62501 14C9.62501 14.4832 10.0168 14.875 10.5 14.875ZM14.875 14C14.875 14.4832 14.4833 14.875 14 14.875C13.5168 14.875 13.125 14.4832 13.125 14C13.125 13.5168 13.5168 13.125 14 13.125C14.4833 13.125 14.875 13.5168 14.875 14ZM10.5 11.375C10.9833 11.375 11.375 10.9832 11.375 10.5C11.375 10.0168 10.9833 9.625 10.5 9.625C10.0168 9.625 9.62501 10.0168 9.62501 10.5C9.62501 10.9832 10.0168 11.375 10.5 11.375ZM14.875 10.5C14.875 10.9832 14.4833 11.375 14 11.375C13.5168 11.375 13.125 10.9832 13.125 10.5C13.125 10.0168 13.5168 9.625 14 9.625C14.4833 9.625 14.875 10.0168 14.875 10.5Z"
                                    fill="#4D578D"
                                  />
                                </svg>
                              </span>
                              <span style="color: #4d578d">{{
                                getNotificationDate(noti) | time: "MMM DD"
                              }}</span>
                            </span>
                          </div>
                        }
                        <div class="awb-id-wrapper">
                          @if (getQuoteAWBNumber(noti)) {
                            <span
                              class="awb-id"
                              style="font-weight: 500; color: #db55c5"
                              ><span style="color: #4d578d; margin-right: 4px"
                                >AWB</span
                              >
                              {{ getQuoteAWBNumber(noti) }}</span
                            >
                          }
                          @if (getQuoteId(noti)) {
                            <span
                              class="awb-id"
                              style="font-weight: 500; color: #db55c5"
                            >
                              <span style="color: #4d578d; margin-right: 4px"
                                >ID</span
                              >
                              {{ getQuoteId(noti) }}</span
                            >
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </li>
        </ul>
      </form>
    </div>
  </div>
}
